import api from "./api";

export const createContent = async (data) => {
  const res = await api.post("/admin/contents", {
    type: data.type,
    base: {
      title: data.base.title,
      date: data.base.date ?? null,
      descr: data.base.descr,
      image: data.base.image
    },
    details: data.details ?? {},
    sessions: data.sessions ?? []
  });

  return res.data;
};

/**
 * GET all contents
 */
export const getAdminContents = async (type = "") => {
  const res = await api.get("/contents", {
    params: { type }
  });
  return res.data;
};

/**
 * GET content by ID
 */

export const getAdminContentById = async (id) => {
  const res = await api.get(`/admin/contents/${id}`);
  return res.data;
};

/**
 * UPDATE content
 */

export const updateContent = async (id, data) => {
  const res = await api.put(`/admin/contents/${id}`, {
    type: data.type,
    base: {
      title: data.base.title,
      date: data.base.date ?? null,
      descr: data.base.descr,
      image: data.base.image ?? null
    },
    details: data.details ?? {},
    sessions: data.sessions ?? []
  });

  return res.data;
};

/**
 * DELETE content
 */
export const deleteContent = async (id) => {
  await api.delete(`/admin/contents/${id}`);
};

export const getContents = async ({ type, page, search }) => {
  const res = await api.get("/contents", {
    params: {
      type,
      page,
      limit: 10,
      search
    }
  });
  return res.data;
};


export const getContentById = async (id) => {
  const res = await api.get(`/contents/${id}`);
  return res.data;
};

export const getLatestContents = async (limit = 5) => {
  const res = await api.get("/contents", {
    params: { limit }
  });
  return res.data;
};
